import React, { FunctionComponent } from "react";
import { useTheme } from "@mui/material";
import { Theme } from "@emotion/react";

export const LineSvgComponent: FunctionComponent = () => {
    const theme = useTheme<Theme>();
    return (
        <svg height="100%" width="100%" viewBox="0 0 150 100">
            <polyline fill="none" points="20 30, 90 20, 40 60, 110 50, 110 70, 130 80" style={{ stroke: theme.shades.one, strokeWidth: 4, strokeLinejoin: "round" }} />
        </svg>
    );
};
